<template lang="html">
  <div :class="{'container' : wrap}">
    <div :class="wrap">
      <div class="PersonCard-container">
        <div class="PersonCard" itemscope itemtype="http://schema.org/Person">
          <div class="PersonCard-noImage" v-if="!person.profile_image">
            <h3>{{person.name.replace(/[^A-Z-ÆØÅ]/g, '')}}</h3>
          </div>
          <figure class="PersonCard-image" itemprop="image" v-else="">
            <image-source
              :ratio=1
              :source="person.profile_image.asset.url"
              :hotspot="person.profile_image.hotspot"
              :crop="person.profile_image.crop"
              :metadata="person.profile_image.asset.metadata"
              :alt="person.name"
              :widths="[200, 200, 600]">
            </image-source>
          </figure>
          <div class="PersonCard-content">
            <div class="content">
              <p class="PersonCard-status" itemprop="jobTitle" v-if="role">
                {{role}}
              </p>
              <h3 itemprop="name">{{person.name}}</h3>
              <p v-if="person.phone">
                <a :href="this.phoneLink(person.phone)">{{person.phone}}</a>
              </p>

              <p class="Person-card-mail-desktop" v-if="person.email">
                <a :href="this.mailTo(person.email)">{{ person.email }}</a>
              </p>

              <a :href="this.mailTo(person.email)" class="Person-card-mail-mobile" v-if="person.email">
                <icon name="envelope-o"></icon>
              </a>

              <a :href="this.twitterLink(person.twitter)" v-if="person.twitter" target="_blank" class="fa-twitter">
                <icon  name="twitter"></icon>
              </a>

              <a :href="person.facebook"  v-if="person.facebook" target="_blank">
                <icon name="facebook-official"></icon>
              </a>

              <a :href="this.instagramLink(person.instagram)" v-if="person.instagram" target="_blank">
                <icon name="instagram"></icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageSource from '@/components/ImageSource'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/envelope-o'
import 'vue-awesome/icons/facebook-official'
import 'vue-awesome/icons/instagram'
import 'vue-awesome/icons/twitter'

export default {
  name: 'person-card',
  components: {
    'image-source': ImageSource,
    Icon
  },
  props: ['person', 'role', 'wrap'],
  methods: {
    imageUrl (url) {
      return `${url}?w=200&h=200`
    },
    phoneLink (number) {
      return `tel:${number}`
    },
    mailTo (mail) {
      return `mailto:${mail}`
    },
    twitterLink (handle) {
      return `https://twitter.com/${handle.replace('@', '')}`
    },
    instagramLink (handle) {
      return `https://instagram.com/${handle.replace('@', '')}`
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/PersonCard.vue